export default {
      id: "ic-plan-colleges-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-colleges-usage",
      toString: function () {
        return this.url;
      }
    }